/**
 * itapplicationreducer.js
 **/
import {cloneDeep} from 'lodash';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {isApiResponseOk, normalize} from '../../util/utils';

function normalizeItApp(itApp) {
	return {
		...itApp,
		scots: itApp.scots?.map((scot) => scot.scotId) || [],
		controls: itApp.controls?.map((control) => control.id) || []
	};
}

export function itApplicationReducer(state = initialState.itapplication, action) {
	switch (action.type) {
		// Get ITApp/SO by Id
		case types.ITAPP_EDIT_GET_BY_ID: {
			if (!isApiResponseOk(action)) {
				return state;
			}
			const entity = action.response?.data?.[0];
			if (!entity) {
				return state;
			}

			const relatedControls = normalize(entity.controls || [], undefined, state.controls);
			const relatedScots = normalize(entity.scots || [], 'scotId', state.scots);

			return {
				...state,
				details: normalizeItApp(entity),
				scots: relatedScots,
				controls: relatedControls
			};
		}

		// Get all SCOTs (store in scots subslice)
		case types.ITAPP_EDIT_GET_ALL_SCOTS: {
			if (!isApiResponseOk(action)) {
				return state;
			}
			return {
				...state,
				scots: normalize(action.response?.data || [])
			};
		}

		// Get all Controls (store in controls subslice)
		case types.ITAPP_EDIT_GET_ALL_CONTROLS: {
			if (!isApiResponseOk(action)) {
				return state;
			}
			return {
				...state,
				controls: normalize(action.response?.data || [])
			};
		}

		case types.UPDATE_ITAPPLICATION:
		case types.UPDATE_IT_SO: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			return {...state, details: normalizeItApp(action.response)};
		}

		case types.ITAPP_EDIT_CLEAR: {
			return cloneDeep(initialState.itapplication);
		}

		default:
			return state;
	}
}

export function itApplicationDataReducer(state = initialState.itapplicationData, action) {
	switch (action.type) {
		case types.GET_IT_APPLICATION: {
			if (action.response && action.response.data) {
				return {
					...state,
					...action.response,
					data: [...action.response.data]
				};
			}
			break;
		}

		case types.UPDATE_ITAPPLICATION: {
			if (Object.keys(state).length !== 0) {
				if (action.response && !action.error) {
					let clonedState = cloneDeep(state);
					clonedState.data.forEach((itApp, i) => {
						if (itApp.id === action.response.id) {
							clonedState.data[i] = { ...itApp, ...action.response };
						}
					});
					return clonedState;
				}
			}
			return state;
		}

		case types.DELETE_ITAPPLICATION: {
			if (Object.keys(state).length !== 0) {
				if (!action.error) {
					let clonedState = cloneDeep(state);
					clonedState.data = clonedState.data.filter((itApp) => itApp.id !== action.itApplicationId);
					return clonedState;
				}
			}
			return state;
		}
		case types.GET_CONTROL_BY_ID: {
			if (action.response) {
				const itApplications = state.data?.concat(
					action.response?.itApplications?.filter(
						(itApp) => !state.data.some((existingItApp) => existingItApp.id === itApp.id)
					)
				);
				return {
					...state,
					data: itApplications
				};
			}
		}

		case types.CREATE_ITAPPLICATION_SO: {
			if (Object.keys(state).length !== 0) {
				if (action.response && !action.error) {
					let clonedState = cloneDeep(state);
					clonedState.data.push(action.response);
					return clonedState;
				}
			}
			return state;
		}

		default:
			return state;
	}
}

export function itApplicationDetailsReducer(state = initialState.itAppSODetails, action) {
	switch (action.type) {
		case types.GET_ITAPPSO_BY_ID:
			if (action.response) {
				return action.response;
			}
			break;
		case types.UPDATE_IT_RISK: {
			if (state && state.data) {
				// This is for get by id call which will always return one record in data array.
				const updatedRisks = state.data[0].itRisks.map((risk) => { 
					if (risk.itRiskId === action.response.id) {
						return {
							...risk,
							...action.response
						};
					}
					return risk;
				});

				// update first item in data array 
				const updatedData = [...state.data];
				updatedData[0] = {
					...updatedData[0],
					itRisks: updatedRisks
				};

				return {
					...state,
					data: updatedData
				};
			}
		}
		break;
		default:
			return state;
	}
}
